var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { CognitoUtil } from '../common/cognito.service';
import { CustomcognitoServiceUtil } from '../customcommon/customcognito.service';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import { HttpService } from '../common/http.service';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
var CustomuserService = /** @class */ (function () {
    function CustomuserService(httpS, cognitoUtil, customcognitoServiceUtil, router, translate) {
        this.httpS = httpS;
        this.cognitoUtil = cognitoUtil;
        this.customcognitoServiceUtil = customcognitoServiceUtil;
        this.router = router;
        this.translate = translate;
        this.token = localStorage.getItem('user');
        if (!this.token) {
            this.logoutCustom();
        }
    }
    /**
     * logout
     */
    CustomuserService.prototype.logoutCustom = function () {
        // console.log('UserLoginService: Logging out');
        this.clearUserData();
        // this.router.navigate(['logincustom']);
    };
    CustomuserService.prototype.clearUserData = function () {
        var user = this.cognitoUtil.getCurrentUser();
        if (user) {
            var cookiesWindow = localStorage.getItem('hideCookieWindow');
            localStorage.clear();
            if (cookiesWindow) {
                localStorage.setItem('hideCookieWindow', 'false');
            }
            user.signOut();
        }
    };
    /**
     * login
     * @param user
     * @returns {Observable<any>}
     */
    CustomuserService.prototype.loginCustom = function (user) {
        var _this = this;
        // console.log('custom login service called');
        var that = this;
        this.clearUserData();
        return new Observable(function (observer) {
            // console.log(user);
            var authenticationData = {
                Username: user.email,
                Password: user.password
            };
            var authenticationDetails = new AuthenticationDetails(authenticationData);
            var userData = {
                Username: user.email,
                Pool: _this.cognitoUtil.getUserPool()
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (result) {
                    that.httpS.token = null;
                    // console.log(result);
                    observer.next(result);
                },
                onFailure: function (err) {
                    // console.log(err);
                    var response = { status: '' };
                    if (err.code === 'NotAuthorizedException') {
                        response.status = '428';
                    }
                    else if (err.code === 'UserNotConfirmedException') {
                        response.status = '434';
                    }
                    else {
                        response.status = '429';
                    }
                    observer.error(response);
                }
            });
        });
    };
    /*  forgotPassword(user) {
        return this.httpS.post('/forgot', user, true);
      }*/
    /**
     * forgotPassword
     * @param {string} username
     * @returns {Observable<any>}
     */
    CustomuserService.prototype.forgotPassword = function (username) {
        var _this = this;
        // console.log(username);
        return new Observable(function (observer) {
            var userData = {
                Username: username,
                Pool: _this.cognitoUtil.getUserPool()
            };
            var cognitoUser = new CognitoUser(userData);
            // console.log(cognitoUser);
            cognitoUser.forgotPassword({
                onSuccess: function (result) {
                    // console.log(result);
                },
                onFailure: function (error) {
                    var response = { status: '' };
                    if (error.code === 'UserNotFoundException') {
                        response.status = '429';
                    }
                    else if (error.message === 'Cannot reset password for the user as there is no registered/verified email or phone_number') {
                        response.status = '402';
                    }
                    else if (error.code === 'LimitExceededException') {
                        response.status = '441';
                    }
                    else {
                        response.status = '500';
                    }
                    observer.error(response);
                },
                inputVerificationCode: function () {
                    // console.log('verification code sent');
                    observer.next();
                }
            });
        });
    };
    /**
     * confirmNewPassword
     * @param {string} email
     * @param {string} verificationCode
     * @param {string} password
     * @returns {Observable<any>}
     */
    CustomuserService.prototype.confirmNewPassword = function (email, verificationCode, password) {
        var _this = this;
        return new Observable(function (observer) {
            // console.log(email, verificationCode, password);
            var userData = {
                Username: email,
                Pool: _this.cognitoUtil.getUserPool()
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.confirmPassword(verificationCode, password, {
                onSuccess: function () {
                    // console.log('password reset success');
                    observer.next(null);
                },
                onFailure: function (error) {
                    // console.log(error);
                    var response = { status: '' };
                    if (error.code === 'CodeMismatchException') {
                        response.status = '432';
                    }
                    else if (error.code === 'LimitExceededException') {
                        response.status = '436';
                    }
                    else {
                        response.status = '408';
                    }
                    observer.error(response);
                }
            });
        });
    };
    /**
     * signup
     * @param user
     * @returns {Observable<any>}
     */
    CustomuserService.prototype.signupCustom = function (user) {
        /*return new Observable((observer) => {
    
          console.log(JSON.stringify(user));
          const attributeList = [];
    
          const dataEmail = {
            Name: 'email',
            Value: user.email
          };
          const dataName = {
            Name: 'name',
            Value: user.name
          };
          const dataPhone = {
            Name: 'phone_number',
            Value: user.phone.replace(' ', '')
          };
    
          attributeList.push(new CognitoUserAttribute(dataEmail));
          attributeList.push(new CognitoUserAttribute(dataName));
          attributeList.push(new CognitoUserAttribute(dataPhone));
          console.log(attributeList);
          this.cognitoUtil.getUserPool().signUp(user.email, user.password, attributeList, null, function (err, result) {
            if (err) {
              console.error(err);
              observer.error(err);
            } else {
              console.log('signup success');
              observer.next(result);
            }
          });
      });  */
        return this.httpS.post('/formeditor/signup', user, true);
        /*const Httpheader = new HttpHeaders();
        Httpheader.set('Content-Type', 'application/json');
        return this.http.post(AppConstant.AWS_API_ENDPOINT + '/signup', user, {headers: Httpheader});*/
    };
    CustomuserService.prototype.changePassword = function (oldPass, newPass) {
        var _this = this;
        return new Observable(function (observer) {
            var user = _this.cognitoUtil.getCurrentUser();
            user.getSession(function (err) {
                if (err) {
                    observer.error(err);
                }
                else {
                    user.changePassword(oldPass, newPass, function (error) {
                        if (error) {
                            var response = { status: '' };
                            if (error.code === 'NotAuthorizedException') {
                                response.status = '430';
                            }
                            else if (error.code === 'LimitExceededException') {
                                response.status = '436';
                            }
                            // console.log(error);
                            observer.error(response);
                        }
                        else {
                            observer.next(user);
                        }
                    });
                }
            });
        });
    };
    CustomuserService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpService, CognitoUtil,
            CustomcognitoServiceUtil, Router, TranslateService])
    ], CustomuserService);
    return CustomuserService;
}());
export { CustomuserService };



//////////////////
// WEBPACK FOOTER
// ./src/app/user/customuser.service.ts
// module id = ./src/app/user/customuser.service.ts
// module chunks = main